(() => {
  const STORAGE_KEY = 'muaazonRecentlyViewed';
  const loaded = new WeakSet();

  const readHandles = () => {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.filter(Boolean) : [];
    } catch { return []; }
  };

  const remember = (handle) => {
    if (!handle) return;
    try {
      const handles = readHandles().filter((item) => item !== handle);
      handles.unshift(handle);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, 12)));
    } catch {}
  };

  const imageUrl = (product) => {
    const image = product?.featured_image;
    if (typeof image === 'string') return image;
    return image?.src || '';
  };

  const appendCard = (grid, product, handle) => {
    const article = document.createElement('article');
    article.className = 'surface';
    article.setAttribute('role', 'listitem');

    const link = document.createElement('a');
    link.href = product?.url || `/products/${encodeURIComponent(handle)}`;
    const src = imageUrl(product);
    if (src) {
      const image = document.createElement('img');
      image.loading = 'lazy';
      image.decoding = 'async';
      image.src = src;
      image.alt = String(product?.title || '');
      link.append(image);
    }
    const title = document.createElement('h3');
    title.textContent = String(product?.title || 'Product');
    link.append(title);
    article.append(link);

    const price = document.createElement('p');
    const currency = String(globalThis.Shopify?.currency?.active || product?.currency || 'USD');
    try {
      price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format((Number(product?.price) || 0) / 100);
    } catch {
      price.textContent = String((Number(product?.price) || 0) / 100);
    }
    article.append(price);
    grid.append(article);
  };

  async function loadSection(section, current) {
    if (!section || loaded.has(section)) return;
    loaded.add(section);
    const grid = section.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;
    const handles = readHandles().filter((handle) => handle !== current).slice(0, 5);
    if (!handles.length) return;

    const requests = handles.map(async (handle) => {
      try {
        const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return null;
        return { handle, product: await response.json() };
      } catch { return null; }
    });

    const results = await Promise.allSettled(requests);
    for (const result of results) {
      const value = result.status === 'fulfilled' ? result.value : null;
      if (value?.product) appendCard(grid, value.product, value.handle);
    }
    if (grid.children.length) section.hidden = false;
  }

  function boot() {
    const current = document.body?.dataset?.productHandle || document.querySelector('[data-product-handle]')?.dataset?.productHandle || '';
    remember(current);
    document.querySelectorAll('[data-recently-viewed-section]').forEach((section) => {
      if (typeof IntersectionObserver !== 'function') { void loadSection(section, current); return; }
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        void loadSection(section, current);
      }, { rootMargin: '600px 0px', threshold: 0 });
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
})();
